import { AthenaImportsSection } from "./AthenaImportsSection";
import { AthenaPostingsSection } from "./AthenaPostingsSection";

// CLE-2948 — a log of Athena activity, not a configuration screen. Athena's settings stay where they
// are: per account on the hospital edit page, and the daily import's source on the SFTP tab.
export function AthenaTab() {
  return (
    <div className="flex flex-column gap-5">
      <section>
        <h2 className="mt-0 mb-3 text-xl">Imports</h2>
        <AthenaImportsSection />
      </section>
      <section>
        <h2 className="mt-0 mb-3 text-xl">Payment postings</h2>
        <AthenaPostingsSection />
      </section>
    </div>
  );
}
